/**
 * プロモーションマスタメンテナンス画面　プロモーションマスタメンテナンスVOクラス
 */
export class KYMW4002PromotionModel {

  public promotionNo: string = <string>'';                                      // プロモーション番号
  public promotionInfo: string = <string>'';                                    // プロモーション情報
  public markCode1: string = <string>'';                                        // マークコード１
  public markCode2: string = <string>'';                                        // マークコード２
  public markCode3: string = <string>'';                                        // マークコード３
  public markCode4: string = <string>'';                                        // マークコード４
  public markCode5: string = <string>'';                                        // マークコード５
  public multiPublishFlag: string = <string>'0';                                // Ｗ掲載フラグ(0：多重掲載なし、1：多重掲載あり)

}
